import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { ExpandService } from 'libs/shared/util-common/src/lib/expand.service';
import { ButtonDirective, IconDirective, TooltipDirective } from 'shared/ui-common';

import { Ucum } from '@treetop/shared/model';

import { ExpandCollapseToggleComponent } from '../../../../../../../../../guideline-page/src/lib/guideline-view/footer/expand-collapse-toggle/expand-collapse-toggle.component';

export interface GuidelinePublishDialogData {
  revisionDate: Date | Ucum;
  updateMessage: string;
  sendEmailNotification: boolean;
}

@Component({
  selector: 'tt-guideline-review-update-footer',
  templateUrl: './review-update-footer.component.html',
  styleUrls: ['./review-update-footer.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslocoModule, ExpandCollapseToggleComponent, ButtonDirective, IconDirective, TooltipDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewUpdateFooterComponent {
  private expandService = inject(ExpandService);

  @Input() public version?: string;
  @Input() public mode?: 'acceptUpdate' | 'publishReview';

  @Output() public closeButtonClicked = new EventEmitter<void>();
  @Output() public publishButtonClicked = new EventEmitter<void>();

  protected handleDefaultViewClicked() {
    this.expandService.reset();
  }

  protected get buttonVariant(): string {
    return this.mode === 'acceptUpdate' ? 'approved' : 'published';
  }
}
